import { render, staticRenderFns } from "./LiveChatInputQuestion.vue?vue&type=template&id=557359fa&scoped=true&"
import script from "./LiveChatInputQuestion.vue?vue&type=script&lang=js&"
export * from "./LiveChatInputQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatInputQuestion.vue?vue&type=style&index=0&id=557359fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557359fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
